const tScale1 = {
  1: { fontSize: '33px', leading: '40px', paragraph: '20px' },
  2: { fontSize: '28px', leading: '36px', paragraph: '18px' },
  3: { fontSize: '23px', leading: '30px', paragraph: '15px' },
  4: { fontSize: '19px', leading: '27px', paragraph: '14px' },
  5: { fontSize: '16px', leading: '24px', paragraph: '12px' },
  6: { fontSize: '14px', leading: '20px', paragraph: '10px' },
  7: { fontSize: '12px', leading: '16px', paragraph: '8px' },
};

const tScale2 = {
  1: { fontSize: '44px', leading: '50px', paragraph: '25px' },
  2: { fontSize: '35px', leading: '42px', paragraph: '21px' },
  3: { fontSize: '28px', leading: '36px', paragraph: '18px' },
  4: { fontSize: '22px', leading: '31px', paragraph: '16px' },
  5: { fontSize: '16px', leading: '24px', paragraph: '12px' },
  6: { fontSize: '14px', leading: '20px', paragraph: '10px' },
  7: { fontSize: '12px', leading: '16px', paragraph: '8px' },
};

// ExtraLarge is for promo sites really, so lets leave it off for now
const tScale3 = {
  1: { fontSize: '57px', leading: '66px', paragraph: '33px' },
  2: { fontSize: '43px', leading: '52px', paragraph: '26px' },
  3: { fontSize: '32px', leading: '42px', paragraph: '21px' },
  4: { fontSize: '24px', leading: '31px', paragraph: '16px' },
  5: { fontSize: '16px', leading: '24px', paragraph: '12px' },
  6: { fontSize: '14px', leading: '20px', paragraph: '10px' },
  7: { fontSize: '12px', leading: '16px', paragraph: '8px' },
};

const tScaleValues = {
  tScale1,
  tScale2,
  tScale3,
};

const getFontSize = (rs) => (value) => {
  return tScaleValues[`tScale${rs}`][value].fontSize;
};
const getLeading = (rs) => (value) => {
  return tScaleValues[`tScale${rs}`][value].leading; // line-height
};
const getParagraphSpace = (rs) => (value) => {
  return tScaleValues[`tScale${rs}`][value].paragraph;
};

const getRScaleValue = (rs) => {
  const rScale = {};

  for (let i = 0; i <= 12; i++) {
    let delta = 0;
    if (rs === 2) {
      delta = i > 9 ? 8 : 4;
    } else if (rs === 3) {
      // Extra Large is for promo sites really, so lets leave it off for now.
      delta = i > 9 ? 16 : 8;
    }
    rScale[i] = `${i * 4 + delta}px`;
  }

  return (value) => {
    return rScale[value];
  };
};

const getFScaleValue = (value) => {
  return `${value}px`;
};

const SMALL_SCALE = 1;
const LARGE_SCALE = 2;

const buildScales = (props, isMediumOrLower) => {
  const { fontSize, leading, space, rUnit, fUnit } = props;
  const rs = isMediumOrLower ? SMALL_SCALE : LARGE_SCALE;

  return {
    fontSize: fontSize ? fontSize : getFontSize(rs),
    leading: leading ? leading : getLeading(rs),
    space: space ? space : getParagraphSpace(rs),
    rUnit: rUnit ? rUnit : getRScaleValue(rs),
    fUnit: fUnit ? fUnit : getFScaleValue,
  };
};

export default buildScales;
